// Minimalistic runtime type introspection for basic (and vCard value) types.
// Modeled after [https://github.com/colinhacks/zod](Zod).
import { scan1DValue, scan2DValue, scanSingleValue } from './scan.js';
var RuntimeTypeAnnotation = /** @class */ (function () {
    function RuntimeTypeAnnotation(name, parse) {
        this.name = name;
        this.parse = parse;
    }
    return RuntimeTypeAnnotation;
}());
export { RuntimeTypeAnnotation };
export var StringType = new RuntimeTypeAnnotation('string', function (rawValue, errorCallback) { return scanSingleValue(rawValue, errorCallback); });
export var NonEmptyStringArrayType = new RuntimeTypeAnnotation('string[+]', function (rawValue) { return scan1DValue(rawValue, ','); });
export var NumberType = new RuntimeTypeAnnotation('number', function (rawValue) { return parseInt(rawValue, 10); });
export var ADRType = new RuntimeTypeAnnotation('ADR', function (rawValue) {
    var _a = scan2DValue(rawValue), postOfficeBox = _a[0], extendedAddress = _a[1], streetAddress = _a[2], locality = _a[3], region = _a[4], postalCode = _a[5], countryName = _a[6];
    return {
        postOfficeBox: postOfficeBox,
        extendedAddress: extendedAddress,
        streetAddress: streetAddress,
        locality: locality,
        region: region,
        postalCode: postalCode,
        countryName: countryName,
    };
});
export var NType = new RuntimeTypeAnnotation('N', function (rawValue) {
    var _a = scan2DValue(rawValue), familyNames = _a[0], givenNames = _a[1], additionalNames = _a[2], honorificPrefixes = _a[3], honorificSuffixes = _a[4];
    return {
        familyNames: familyNames,
        givenNames: givenNames,
        additionalNames: additionalNames,
        honorificPrefixes: honorificPrefixes,
        honorificSuffixes: honorificSuffixes,
    };
});
export var GENDERType = new RuntimeTypeAnnotation('GENDER', function (rawValue) {
    var _a = scan1DValue(rawValue, ';'), sex = _a[0], text = _a[1];
    return { sex: sex, text: text };
});
export var CLIENTPIDMAPType = new RuntimeTypeAnnotation('CLIENTPIDMAP', function (rawValue) {
    var _a = scan1DValue(rawValue, ';'), pidRef = _a[0], uri = _a[1];
    return { pidRef: parseInt(pidRef, 10), uri: uri };
});
/**
 * Creates a type guard function, which will check whether its parameter, the key,
 * exists in the schema. The schema must be an actual object (typically a const),
 * it's type is inferred by the generic.
 *
 * Asserts to the type system that key is in the schema. This cannot be done directly
 * (as type information is only available at compile time), therefore, we need to
 * infer the type information from the schema (this direction is possible) and
 * verify at runtime against the schema.
 * @param schema The schema to check against (an actual variable/const, not a type!)
 * @returns The type guard function.
 */
export function keyTypeGuard(schema) {
    return function (key) {
        return key in schema;
    };
}
/**
 * WIP
 *
 * Creates a type guard function, which will check whether its parameter, the key,
 * exists in the RuntimeTypeAnnotation schema with the given type name.
 * The schema must be an actual object (typically a const),
 * and the generic T must be `keyof typeof schema`.
 *
 * Asserts to the type system that key is in T. This cannot be done directly
 * (as type information is only available at compile time), therefore, we need to
 * infer the type information from the schema (this direction is possible) and
 * verify at runtime against the schema.
 * @param schema The schema to check against (an actual variable/const, not a type!)
 * @returns The type guard function.
 */
// export function rtTypeGuard<Base extends Record<string, any>, Type, Name>(
//   schema: Record<string, RuntimeTypeAnnotation<any>>,
// ): (key: string) => key is keyof SubType<Base, Type> {
//   return (key): key is T => {
//     return schema[key]?.type;
//   };
// }
//# sourceMappingURL=runtimeTypes.js.map